/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React from 'react'

import { ARCADE_ICONS_NAMES } from './arcade-icons/constants'
import { BaseIcon, IconVariantComponent } from './BaseIcon'

type NamesType = typeof ARCADE_ICONS_NAMES
type NamesKeys = keyof NamesType
export type ArcadeIconNames = NamesType[NamesKeys]

export type ArcadeIconComponent = IconVariantComponent & {
  AccountVerified: IconVariantComponent
  Add: IconVariantComponent
  AlertFill: IconVariantComponent
  AlertReportedFill: IconVariantComponent
  Attach: IconVariantComponent
  Avatar: IconVariantComponent
  BackCentered: IconVariantComponent // manually added
  BankAccount: IconVariantComponent
  BitcoinLightning: IconVariantComponent
  Borrow: IconVariantComponent
  Business: IconVariantComponent
  CameraFill: IconVariantComponent
  CardAdd: IconVariantComponent
  CardBasic: IconVariantComponent
  CardInactive: IconVariantComponent
  CardSupport: IconVariantComponent
  CategoryAuto: IconVariantComponent
  CategoryHealthMedical: IconVariantComponent
  CategoryMoving: IconVariantComponent
  CategoryRent: IconVariantComponent
  CategoryShopping: IconVariantComponent
  Check: IconVariantComponent
  CheckFill: IconVariantComponent
  Clear: IconVariantComponent
  Close: IconVariantComponent
  Collapse: IconVariantComponent
  CommChat: IconVariantComponent
  CommEmail: IconVariantComponent
  CommPhoneFill: IconVariantComponent
  CommSmsFill: IconVariantComponent
  Control: IconVariantComponent
  Copy: IconVariantComponent
  CurrencyUsd: IconVariantComponent
  Data: IconVariantComponent
  Date: IconVariantComponent
  Delivery: IconVariantComponent
  DepositBarcode: IconVariantComponent // manually added
  DepositCheck: IconVariantComponent
  DeviceMobile: IconVariantComponent
  DiscountPercentage: IconVariantComponent
  DiscountTag: IconVariantComponent
  DiscountTagFill: IconVariantComponent
  Document: IconVariantComponent
  Download: IconVariantComponent
  Edit: IconVariantComponent
  Expand: IconVariantComponent
  FailedFill: IconVariantComponent // manually added
  Fast: IconVariantComponent
  Favorite: IconVariantComponent
  FavoriteFill: IconVariantComponent
  Giftcard: IconVariantComponent
  HsaCard: IconVariantComponent
  Hyperlink: IconVariantComponent
  Idea: IconVariantComponent
  InformationOutline: IconVariantComponent
  International: IconVariantComponent
  Like: IconVariantComponent
  Limits: IconVariantComponent
  LinkOut: IconVariantComponent
  Location: IconVariantComponent
  LocationDuo: IconVariantComponent
  LocationFill: IconVariantComponent
  LockLocked: IconVariantComponent
  LogOut: IconVariantComponent
  LogoAfterpay: IconVariantComponent
  MenuAfterpay: IconVariantComponent
  More: IconVariantComponent
  NoCreditCheck: IconVariantComponent
  Notifications: IconVariantComponent
  PayInFour: IconVariantComponent
  PayLater: IconVariantComponent
  Printer: IconVariantComponent
  Push: IconVariantComponent
  RecurringAutomatic: IconVariantComponent
  Refresh: IconVariantComponent
  Refunded: IconVariantComponent
  Savings: IconVariantComponent
  Search: IconVariantComponent
  Send: IconVariantComponent
  SensitiveHidden: IconVariantComponent
  SensitiveVisible: IconVariantComponent
  Share: IconVariantComponent
  ShoppingCart: IconVariantComponent
  SwapCurrency: IconVariantComponent
  TickerDown: IconVariantComponent
  TickerLeft: IconVariantComponent // manually added
  TickerRight: IconVariantComponent // manually added
  TickerUp: IconVariantComponent
  Time: IconVariantComponent
  TransferWire: IconVariantComponent
  Zero: IconVariantComponent
}

export const ArcadeIcon: ArcadeIconComponent = (props) => {
  return <BaseIcon {...props} />
}

const AccountVerified: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ACCOUNTVERIFIED} {...otherProps} />
}
const Add: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ADD} {...otherProps} />
}
const AlertFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ALERTFILL} {...otherProps} />
}
const AlertReportedFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ALERTREPORTEDFILL} {...otherProps} />
}
const Attach: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ATTACH} {...otherProps} />
}
const Avatar: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.AVATAR} {...otherProps} />
}
const BackCentered: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.BACKCENTERED} {...otherProps} />
}
const BankAccount: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.BANKACCOUNT} {...otherProps} />
}
const BitcoinLightning: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.BITCOINLIGHTNING} {...otherProps} />
}
const Borrow: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.BORROW} {...otherProps} />
}
const Business: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.BUSINESS} {...otherProps} />
}
const CameraFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CAMERAFILL} {...otherProps} />
}
const CardAdd: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CARDADD} {...otherProps} />
}
const CardBasic: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CARDBASIC} {...otherProps} />
}
const CardInactive: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CARDINACTIVE} {...otherProps} />
}
const CardSupport: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CARDSUPPORT} {...otherProps} />
}
const CategoryAuto: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CATEGORYAUTO} {...otherProps} />
}
const CategoryHealthMedical: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CATEGORYHEALTHMEDICAL} {...otherProps} />
}
const CategoryMoving: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CATEGORYMOVING} {...otherProps} />
}
const CategoryRent: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CATEGORYRENT} {...otherProps} />
}
const CategoryShopping: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CATEGORYSHOPPING} {...otherProps} />
}
const Check: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CHECK} {...otherProps} />
}
const CheckFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CHECKFILL} {...otherProps} />
}
const Clear: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CLEAR} {...otherProps} />
}
const Close: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CLOSE} {...otherProps} />
}
const Collapse: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COLLAPSE} {...otherProps} />
}
const CommChat: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COMMCHAT} {...otherProps} />
}
const CommEmail: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COMMEMAIL} {...otherProps} />
}
const CommPhoneFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COMMPHONEFILL} {...otherProps} />
}
const CommSmsFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COMMSMSFILL} {...otherProps} />
}
const Control: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CONTROL} {...otherProps} />
}
const Copy: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.COPY} {...otherProps} />
}
const CurrencyUsd: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.CURRENCYUSD} {...otherProps} />
}
const Data: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DATA} {...otherProps} />
}
const Date: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DATE} {...otherProps} />
}
const Delivery: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DELIVERY} {...otherProps} />
}
const DepositBarcode: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DEPOSITBARCODE} {...otherProps} />
}
const DepositCheck: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DEPOSITCHECK} {...otherProps} />
}
const DeviceMobile: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DEVICEMOBILE} {...otherProps} />
}
const DiscountPercentage: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DISCOUNTPERCENTAGE} {...otherProps} />
}
const DiscountTag: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DISCOUNTTAG} {...otherProps} />
}
const DiscountTagFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DISCOUNTTAGFILL} {...otherProps} />
}
const Document: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DOCUMENT} {...otherProps} />
}
const Download: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.DOWNLOAD} {...otherProps} />
}
const Edit: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.EDIT} {...otherProps} />
}
const Expand: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.EXPAND} {...otherProps} />
}
const FailedFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.FAILEDFILL} {...otherProps} />
}
const Fast: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.FAST} {...otherProps} />
}
const Favorite: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.FAVORITE} {...otherProps} />
}
const FavoriteFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.FAVORITEFILL} {...otherProps} />
}
const Giftcard: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.GIFTCARD} {...otherProps} />
}
const HsaCard: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.HSACARD} {...otherProps} />
}
const Hyperlink: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.HYPERLINK} {...otherProps} />
}
const Idea: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.IDEA} {...otherProps} />
}
const InformationOutline: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.INFORMATIONOUTLINE} {...otherProps} />
}
const International: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.INTERNATIONAL} {...otherProps} />
}
const Like: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LIKE} {...otherProps} />
}
const Limits: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LIMITS} {...otherProps} />
}
const LinkOut: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LINKOUT} {...otherProps} />
}
const Location: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOCATION} {...otherProps} />
}
const LocationDuo: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOCATIONDUO} {...otherProps} />
}
const LocationFill: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOCATIONFILL} {...otherProps} />
}
const LockLocked: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOCKLOCKED} {...otherProps} />
}
const LogoAfterpay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOGOAFTERPAY} {...otherProps} />
}
const LogOut: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.LOGOUT} {...otherProps} />
}
const MenuAfterpay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.MENUAFTERPAY} {...otherProps} />
}
const More: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.MORE} {...otherProps} />
}
const NoCreditCheck: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.NOCREDITCHECK} {...otherProps} />
}
const Notifications: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.NOTIFICATIONS} {...otherProps} />
}
const PayInFour: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.PAYINFOUR} {...otherProps} />
}
const PayLater: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.PAYLATER} {...otherProps} />
}
const Printer: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.PRINTER} {...otherProps} />
}
const Push: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.PUSH} {...otherProps} />
}
const RecurringAutomatic: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.RECURRINGAUTOMATIC} {...otherProps} />
}
const Refresh: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.REFRESH} {...otherProps} />
}
const Refunded: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.REFUNDED} {...otherProps} />
}
const Savings: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SAVINGS} {...otherProps} />
}
const Search: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SEARCH} {...otherProps} />
}
const Send: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SEND} {...otherProps} />
}
const SensitiveHidden: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SENSITIVEHIDDEN} {...otherProps} />
}
const SensitiveVisible: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SENSITIVEVISIBLE} {...otherProps} />
}
const Share: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SHARE} {...otherProps} />
}
const ShoppingCart: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SHOPPINGCART} {...otherProps} />
}
const SwapCurrency: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.SWAPCURRENCY} {...otherProps} />
}
const TickerDown: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TICKERDOWN} {...otherProps} />
}
const TickerLeft: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TICKERLEFT} {...otherProps} />
}
const TickerRight: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TICKERRIGHT} {...otherProps} />
}
const TickerUp: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TICKERUP} {...otherProps} />
}
const Time: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TIME} {...otherProps} />
}
const TransferWire: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.TRANSFERWIRE} {...otherProps} />
}
const Zero: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <ArcadeIcon name={ARCADE_ICONS_NAMES.ZERO} {...otherProps} />
}

ArcadeIcon.AccountVerified = AccountVerified
ArcadeIcon.Add = Add
ArcadeIcon.AlertFill = AlertFill
ArcadeIcon.AlertReportedFill = AlertReportedFill
ArcadeIcon.Attach = Attach
ArcadeIcon.Avatar = Avatar
ArcadeIcon.BackCentered = BackCentered
ArcadeIcon.BankAccount = BankAccount
ArcadeIcon.BitcoinLightning = BitcoinLightning
ArcadeIcon.Borrow = Borrow
ArcadeIcon.Business = Business
ArcadeIcon.CameraFill = CameraFill
ArcadeIcon.CardAdd = CardAdd
ArcadeIcon.CardBasic = CardBasic
ArcadeIcon.CardInactive = CardInactive
ArcadeIcon.CardSupport = CardSupport
ArcadeIcon.CategoryAuto = CategoryAuto
ArcadeIcon.CategoryHealthMedical = CategoryHealthMedical
ArcadeIcon.CategoryMoving = CategoryMoving
ArcadeIcon.CategoryRent = CategoryRent
ArcadeIcon.CategoryShopping = CategoryShopping
ArcadeIcon.Check = Check
ArcadeIcon.CheckFill = CheckFill
ArcadeIcon.Clear = Clear
ArcadeIcon.Close = Close
ArcadeIcon.Collapse = Collapse
ArcadeIcon.CommChat = CommChat
ArcadeIcon.CommEmail = CommEmail
ArcadeIcon.CommPhoneFill = CommPhoneFill
ArcadeIcon.CommSmsFill = CommSmsFill
ArcadeIcon.Control = Control
ArcadeIcon.Copy = Copy
ArcadeIcon.CurrencyUsd = CurrencyUsd
ArcadeIcon.Data = Data
ArcadeIcon.Date = Date
ArcadeIcon.Delivery = Delivery
ArcadeIcon.DepositBarcode = DepositBarcode
ArcadeIcon.DepositCheck = DepositCheck
ArcadeIcon.DeviceMobile = DeviceMobile
ArcadeIcon.DiscountPercentage = DiscountPercentage
ArcadeIcon.DiscountTag = DiscountTag
ArcadeIcon.DiscountTagFill = DiscountTagFill
ArcadeIcon.Document = Document
ArcadeIcon.Download = Download
ArcadeIcon.Edit = Edit
ArcadeIcon.Expand = Expand
ArcadeIcon.FailedFill = FailedFill
ArcadeIcon.Fast = Fast
ArcadeIcon.Favorite = Favorite
ArcadeIcon.FavoriteFill = FavoriteFill
ArcadeIcon.Giftcard = Giftcard
ArcadeIcon.HsaCard = HsaCard
ArcadeIcon.Hyperlink = Hyperlink
ArcadeIcon.Idea = Idea
ArcadeIcon.InformationOutline = InformationOutline
ArcadeIcon.International = International
ArcadeIcon.Like = Like
ArcadeIcon.Limits = Limits
ArcadeIcon.LinkOut = LinkOut
ArcadeIcon.Location = Location
ArcadeIcon.LocationDuo = LocationDuo
ArcadeIcon.LocationFill = LocationFill
ArcadeIcon.LockLocked = LockLocked
ArcadeIcon.LogOut = LogOut
ArcadeIcon.LogoAfterpay = LogoAfterpay
ArcadeIcon.MenuAfterpay = MenuAfterpay
ArcadeIcon.More = More
ArcadeIcon.NoCreditCheck = NoCreditCheck
ArcadeIcon.Notifications = Notifications
ArcadeIcon.PayInFour = PayInFour
ArcadeIcon.PayLater = PayLater
ArcadeIcon.Printer = Printer
ArcadeIcon.Push = Push
ArcadeIcon.RecurringAutomatic = RecurringAutomatic
ArcadeIcon.Refresh = Refresh
ArcadeIcon.Refunded = Refunded
ArcadeIcon.Savings = Savings
ArcadeIcon.Search = Search
ArcadeIcon.Send = Send
ArcadeIcon.SensitiveHidden = SensitiveHidden
ArcadeIcon.SensitiveVisible = SensitiveVisible
ArcadeIcon.Share = Share
ArcadeIcon.ShoppingCart = ShoppingCart
ArcadeIcon.SwapCurrency = SwapCurrency
ArcadeIcon.TickerDown = TickerDown
ArcadeIcon.TickerLeft = TickerLeft
ArcadeIcon.TickerRight = TickerRight
ArcadeIcon.TickerUp = TickerUp
ArcadeIcon.Time = Time
ArcadeIcon.TransferWire = TransferWire
ArcadeIcon.Zero = Zero
